/* =========================================================================
   Douce Nuit — logique partagee pour les 18 sections de la page produit.
   Communication entre sections via CustomEvent sur document :
     - dn:variant:change  { ...variant Shopify (id, price, available, ...) }
     - dn:quantity:change { quantity }
     - dn:cart:added      { reponse de /cart/add.js }
   ========================================================================= */
(function () {
  "use strict";

  var EVENT_VARIANT = "dn:variant:change";
  var EVENT_QUANTITY = "dn:quantity:change";
  var EVENT_CART_ADDED = "dn:cart:added";

  function formatMoneyFallback(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return formatMoneyFallback(cents);
  }

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  /* ---------------- Galerie produit (bloc bonus) ---------------- */
  document.addEventListener("click", function (event) {
    var target = event.target;
    var thumb = target && target.closest ? target.closest("[data-dn-gallery-thumb]") : null;
    if (!thumb) return;
    event.preventDefault();

    var gallery = thumb.closest("[data-dn-gallery]");
    if (!gallery) return;

    var mainImg = gallery.querySelector(".dn-gallery__main img");
    var fullSrc = thumb.getAttribute("data-full");
    if (!mainImg || !fullSrc) return;

    /* L'image principale est rendue par Liquid avec un attribut srcset :
       le navigateur le choisit EN PRIORITE sur src, donc changer src seul
       ne changeait rien a l'ecran. On retire srcset/sizes avant. */
    mainImg.removeAttribute("srcset");
    mainImg.removeAttribute("sizes");
    mainImg.setAttribute("src", fullSrc);

    var thumbImg = thumb.querySelector("img");
    if (thumbImg && thumbImg.getAttribute("alt")) {
      mainImg.setAttribute("alt", thumbImg.getAttribute("alt"));
    }

    var thumbs = gallery.querySelectorAll("[data-dn-gallery-thumb]");
    Array.prototype.forEach.call(thumbs, function (el) {
      var active = el === thumb;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-current", active ? "true" : "false");
    });
  });

  /* ---------------- Selecteur de variante (bloc 3) ---------------- */
  function getSelectedOptions(picker) {
    var selected = [];
    picker.querySelectorAll("[data-option-position]").forEach(function (optionGroup) {
      var position = Number(optionGroup.getAttribute("data-option-position"));
      var active = optionGroup.querySelector('.dn-swatch[aria-pressed="true"]');
      selected[position] = active ? active.getAttribute("data-value") : undefined;
    });
    return selected;
  }

  function findMatchingVariant(picker, selected) {
    var dataEl = picker.querySelector("[data-dn-variants-json]");
    if (!dataEl) return null;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return null;
    }
    return variants.filter(function (variant) {
      return variant.options.every(function (value, index) {
        return selected[index] === undefined || selected[index] === value;
      });
    })[0] || null;
  }

  document.addEventListener("click", function (event) {
    var swatch = event.target.closest(".dn-swatch");
    if (!swatch || swatch.hasAttribute("disabled")) return;

    var picker = swatch.closest("[data-dn-variant-picker]");
    if (!picker) return;

    var group = swatch.closest("[data-option-position]");
    if (!group) return;
    var position = group.getAttribute("data-option-position");

    picker.querySelectorAll('[data-option-position="' + position + '"] .dn-swatch').forEach(function (el) {
      el.setAttribute("aria-pressed", "false");
    });
    swatch.setAttribute("aria-pressed", "true");

    var variant = findMatchingVariant(picker, getSelectedOptions(picker));
    if (variant) {
      document.dispatchEvent(new CustomEvent(EVENT_VARIANT, { detail: variant }));
    }
  });

  /* ---------------- Bundle & Save (bloc 4) ---------------- */
  document.addEventListener("click", function (event) {
    var row = event.target.closest(".dn-bundle-row");
    if (!row) return;
    var table = row.closest("[data-dn-bundle]");
    if (!table) return;

    table.querySelectorAll(".dn-bundle-row").forEach(function (el) {
      el.setAttribute("aria-checked", "false");
    });
    row.setAttribute("aria-checked", "true");

    var quantity = Number(row.getAttribute("data-qty")) || 1;
    document.dispatchEvent(new CustomEvent(EVENT_QUANTITY, { detail: { quantity: quantity } }));
  });

  /* ---------------- Sections a l'ecoute des changements ---------------- */
  document.addEventListener(EVENT_VARIANT, function (event) {
    var variant = event.detail;
    if (!variant) return;

    document.querySelectorAll("[data-dn-price-current]").forEach(function (el) {
      el.textContent = formatMoney(variant.price);
    });
    document.querySelectorAll("[data-dn-price-compare]").forEach(function (el) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    document.querySelectorAll("[data-dn-variant-id-input]").forEach(function (el) {
      el.value = variant.id;
    });
    document.querySelectorAll("[data-dn-atc-button]").forEach(function (el) {
      el.disabled = !variant.available;
      var label = variant.available ? el.getAttribute("data-label-available") : el.getAttribute("data-label-sold-out");
      if (label) el.textContent = label;
    });
    document.querySelectorAll("[data-dn-sticky-variant]").forEach(function (el) {
      el.textContent = variant.title || "";
    });
    document.querySelectorAll("[data-dn-sticky-price]").forEach(function (el) {
      el.textContent = formatMoney(variant.price);
    });

    /* Image principale synchronisee avec la variante selectionnee */
    if (variant.featured_image && variant.featured_image.src) {
      document.querySelectorAll("[data-dn-gallery] .dn-gallery__main img").forEach(function (img) {
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
        img.setAttribute("src", variant.featured_image.src);
      });
    }
  });

  document.addEventListener(EVENT_QUANTITY, function (event) {
    var quantity = (event.detail && event.detail.quantity) || 1;
    document.querySelectorAll("[data-dn-quantity-input]").forEach(function (el) {
      el.value = quantity;
    });
  });

  /* ---------------- Ajout au panier en AJAX (bloc 5) ---------------- */
  document.addEventListener("submit", async function (event) {
    var form = event.target.closest("[data-dn-atc-form]");
    if (!form) return;
    event.preventDefault();
    if (form.dataset.dnSubmitting === "true") return;
    form.dataset.dnSubmitting = "true";

    var button = form.querySelector("[data-dn-atc-button]");
    var errorEl = form.querySelector("[data-dn-atc-error]");
    var successEl = form.querySelector("[data-dn-atc-success]");
    var variantInput = form.querySelector("[data-dn-variant-id-input]");
    var quantityInput = form.querySelector("[data-dn-quantity-input]");
    var quantity = quantityInput ? Number(quantityInput.value) || 1 : 1;
    var deferred;
    var added = false;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";

    if (errorEl) errorEl.hidden = true;
    if (successEl) successEl.hidden = true;
    if (button) button.disabled = true;

    try {
      // Use the same event and section rendering contract as Horizon's product form.
      var events = await import("@shopify/events");
      var CartLinesUpdateEvent = events.CartLinesUpdateEvent;
      var sectionIds = Array.from(new Set(Array.from(document.querySelectorAll("cart-items-component"))
        .map(function (item) { return item.dataset.sectionId; }).filter(Boolean)));
      deferred = CartLinesUpdateEvent.createPromise();
      deferred.promise.catch(function () {});
      form.dispatchEvent(new CartLinesUpdateEvent({
        action: "add",
        context: "product",
        lines: [{ merchandiseId: variantInput.value, quantity: quantity }],
        promise: deferred.promise
      }));

      var response = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: variantInput.value, quantity: quantity }],
          sections: sectionIds.join(","),
          sections_url: window.location.pathname
        })
      });
      var data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || "Erreur lors de l'ajout au panier.");
      }
      added = true;
      document.dispatchEvent(new CustomEvent(EVENT_CART_ADDED, { detail: data }));

      var cartResponse = await fetch(root + "cart.js", {
        headers: { Accept: "application/json" },
        cache: "no-store"
      });
      if (!cartResponse.ok) throw new Error("Impossible d'actualiser le panier.");
      var cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: data.sections,
          source: "dn-product-page",
          sourceId: form.id,
          itemCount: quantity,
          didError: false
        }
      });
      if (successEl) successEl.hidden = false;
    } catch (err) {
      if (deferred) deferred.reject(err);
      if (errorEl) {
        errorEl.textContent = added
          ? "Produit ajouté. Actualisez la page pour afficher votre panier."
          : err.message;
        errorEl.hidden = false;
      }
    } finally {
      delete form.dataset.dnSubmitting;
      if (button) button.disabled = false;
    }
  });

  /* ---------------- Barre sticky (bloc 7) ----------------
     Le script est charge dans <head> : il faut attendre le DOM, sinon
     les elements ci-dessous sont introuvables et la barre ne s'affiche jamais. */
  onReady(function () {
    var stickyBar = document.querySelector("[data-dn-sticky-bar]");
    var buyBoxAnchor = document.querySelector("[data-dn-atc-form]");

    if (!stickyBar || !buyBoxAnchor || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle("is-visible", scrolledPast);
      });
    }, { threshold: 0 });
    observer.observe(buyBoxAnchor);

    stickyBar.addEventListener("click", function (event) {
      if (event.target.closest("[data-dn-sticky-cta]")) {
        var mainButton = buyBoxAnchor.querySelector("[data-dn-atc-button]");
        if (mainButton) mainButton.click();
      }
    });
  });
})();
